
// 默认的提供的大屏配置模版
export const SCREEN_TEMPLATE_LIST = [
  {
    panelName: '跨境电商出口贸易',
    templateId: 1,
    panelThumbnail: 'https://oss.qlinyun.com/test/picture/HxaGtENW5A6T5CbJEpFfJaQYc5M8BM8R.jpg',
    panelWidth: 1920,
    panelHeight: 1080,
    panelProportion: '16:9',
    panelTitle: null,
    panelTemplate: null,
    backgroundType: 2,
    backgroundColor: '#071228',
    backgroundTemplate: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background1.png',
    jumpPanelSn: null,
    jumpDelaySecond: null,
    chartColors: 'default',
    chartViews: [
      {
        chartTitle: '跨境电商出口额（万元）',
        chartTitleTemplate: null,
        chartComponent: 'areaLine',
        chartComponentType: 'LineChart',
        chartX: 40,
        chartY: 138,
        chartWidth: 580,
        chartHeight: 380,
        chartSet: '{"chartStyle": {"smooth": false, "isLabel": true, "carousel": false, "fontSize": 12, "carouselDelay": 3}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border1.png"}}',
        jumpPanelSn: null,
        sort: 10,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "1月", "col_1": "168", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 0}, {"col_0": "2月", "col_1": "123", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 1}, {"col_0": "3月", "col_1": "546", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 2}, {"col_0": "4月", "col_1": "165", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 3}, {"col_0": "5月", "col_1": "156", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 4}, {"col_0": "6月", "col_1": "154", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 5}, {"col_0": "7月", "col_1": "354", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 6}, {"col_0": "8月", "col_1": "245", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 7}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '跨境出口行业分布',
        chartTitleTemplate: null,
        chartComponent: 'pieCircular',
        chartComponentType: 'PieChart',
        chartX: 40,
        chartY: 604,
        chartWidth: 580,
        chartHeight: 380,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": true, "fontSize": 12, "isLegend": false, "labelContent": "percent", "carouselDelay": 3, "externalRadius": 59, "internalRadius": 35, "legendPosition": "top"}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border1.png"}}',
        jumpPanelSn: null,
        sort: 11,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "家居家装", "col_1": "125", "index": 0}, {"col_0": "美妆护肤", "col_1": "200", "index": 1}, {"col_0": "服饰鞋包", "col_1": "56", "index": 2}, {"col_0": "食品保健", "col_1": "145", "index": 3}, {"col_0": "运动户外", "col_1": "123", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 4}, {"col_0": "生活服务", "col_1": "513", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 5}, {"col_0": "3C数码", "col_1": "123", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 6}, {"col_0": "母婴用品", "col_1": "512", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 7}, {"col_0": "文化娱乐", "col_1": "41", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 8}, {"col_0": "机车配件", "col_1": "52", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 9}, {"col_0": "其他", "col_1": "63", "col_2": "", "col_3": "", "col_4": "", "col_5": "", "index": 10}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '跨境企业出口额',
        chartTitleTemplate: null,
        chartComponent: 'scrollTable',
        chartComponentType: 'ScrollTable',
        chartX: 668,
        chartY: 604,
        chartWidth: 580,
        chartHeight: 380,
        chartSet: '{"chartStyle": {"step": 0.6, "color": "#333", "stripe": true, "fontSize": 14, "direction": 1, "hoverStop": true, "carouselDelay": 3}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"color": "#0276fa", "border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border1.png"}}',
        jumpPanelSn: null,
        sort: 12,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86", "index": 0}, {"col_0": "二月", "col_1": "112", "col_2": "134", "index": 1}, {"col_0": "三月", "col_1": "456", "col_2": "235", "index": 2}, {"col_0": "四月", "col_1": "145", "col_2": "84", "index": 3}, {"col_0": "五月", "col_1": "165", "col_2": "853", "col_3": "", "col_4": "", "col_5": "", "index": 4}, {"col_0": "六月", "col_1": "466", "col_2": "755", "col_3": "", "col_4": "", "col_5": "", "index": 5}, {"col_0": "七月", "col_1": "125", "col_2": "453", "col_3": "", "col_4": "", "col_5": "", "index": 6}, {"col_0": "八月", "col_1": "635", "col_2": "325", "col_3": "", "col_4": "", "col_5": "", "index": 7}, {"col_0": "九月", "col_1": "124", "col_2": "354", "col_3": "", "col_4": "", "col_5": "", "index": 8}, {"col_0": "十月", "col_1": "652", "col_2": "321", "col_3": "", "col_4": "", "col_5": "", "index": 9}, {"col_0": "十一月", "col_1": "244", "col_2": "123", "col_3": "", "col_4": "", "col_5": "", "index": 10}, {"col_0": "十二月", "col_1": "123", "col_2": "456", "col_3": "", "col_4": "", "col_5": "", "index": 11}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '出口市场分布',
        chartTitleTemplate: null,
        chartComponent: 'pieCircular',
        chartComponentType: 'PieChart',
        chartX: 1280,
        chartY: 138,
        chartWidth: 580,
        chartHeight: 380,
        chartSet: '{"chartStyle": {"isLabel": false, "carousel": false, "fontSize": 12, "isLegend": true, "labelContent": "percent", "carouselDelay": 3, "externalRadius": 70, "internalRadius": 44, "legendPosition": "top"}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border1.png"}}',
        jumpPanelSn: null,
        sort: 13,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "杭州市", "col_1": "125"}, {"col_0": "温州市", "col_1": "200"}, {"col_0": "金华市", "col_1": "56"}, {"col_0": "舟山市", "col_1": "145"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '2022年跨境电商累计出口额（万）',
        chartTitleTemplate: null,
        chartComponent: 'number',
        chartComponentType: 'Number',
        chartX: 765,
        chartY: 150,
        chartWidth: 386,
        chartHeight: 203,
        chartSet: '{"chartStyle": {"color": "#fff", "fontSize": 38}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 16}, "borderStyle": {"color": "#0276fa", "border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 14,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "￥11,92,0000", "index": 0}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '前10大出口国家',
        chartTitleTemplate: null,
        chartComponent: 'verticalBar',
        chartComponentType: 'BarChart',
        chartX: 1280,
        chartY: 604,
        chartWidth: 580,
        chartHeight: 380,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12, "borderWidth": 10, "borderRadius": 10, "carouselDelay": 3}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border1.png"}}',
        jumpPanelSn: null,
        sort: 15,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86"}, {"col_0": "二月", "col_1": "112", "col_2": "134"}, {"col_0": "三月", "col_1": "456", "col_2": "235"}, {"col_0": "四月", "col_1": "145", "col_2": "84"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: 'XX跨境电商出口数据大屏',
        chartTitleTemplate: null,
        chartComponent: 'text',
        chartComponentType: 'TextBlock',
        chartX: 774,
        chartY: 10,
        chartWidth: 369,
        chartHeight: 50,
        chartSet: '{"chartStyle": {}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 26}, "borderStyle": {"border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 17,
        chartViewData: {
          chartData: '[]',
          initDataFlag: 1,
        },
      },
    ],
  },
  {
    panelName: '跨境电商零售',
    templateId: 2,
    panelThumbnail: 'https://oss.qlinyun.com/test/picture/mm8eEPyHn6Bk5CWHCWXGtskMA5j2isP6.jpg',
    panelWidth: 1920,
    panelHeight: 1080,
    panelProportion: '16:9',
    panelTitle: null,
    panelTemplate: null,
    backgroundType: 2,
    backgroundColor: '#071228',
    backgroundTemplate: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background2.png',
    jumpPanelSn: null,
    jumpDelaySecond: null,
    chartColors: 'iceBlue',
    chartViews: [
      {
        chartTitle: '出口额(万元)',
        chartTitleTemplate: null,
        chartComponent: 'line',
        chartComponentType: 'LineChart',
        chartX: 60,
        chartY: 120,
        chartWidth: 540,
        chartHeight: 280,
        chartSet: '{"chartStyle": {"smooth": false, "isLabel": true, "carousel": false, "fontSize": 12, "carouselDelay": 3}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png"}}',
        jumpPanelSn: null,
        sort: 10,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86"}, {"col_0": "二月", "col_1": "112", "col_2": "134"}, {"col_0": "三月", "col_1": "456", "col_2": "235"}, {"col_0": "四月", "col_1": "145", "col_2": "84"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '出口行业分布',
        chartTitleTemplate: null,
        chartComponent: 'pieCircular',
        chartComponentType: 'PieChart',
        chartX: 60,
        chartY: 430,
        chartWidth: 540,
        chartHeight: 280,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12, "isLegend": false, "labelContent": "percent", "carouselDelay": 3, "externalRadius": 70, "internalRadius": 30, "legendPosition": "top"}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png"}}',
        jumpPanelSn: null,
        sort: 11,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "杭州市", "col_1": "125"}, {"col_0": "温州市", "col_1": "200"}, {"col_0": "金华市", "col_1": "56"}, {"col_0": "舟山市", "col_1": "145"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '前10大出口国家',
        chartTitleTemplate: null,
        chartComponent: 'verticalBar',
        chartComponentType: 'BarChart',
        chartX: 60,
        chartY: 730,
        chartWidth: 540,
        chartHeight: 300,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12, "borderWidth": 10, "borderRadius": 10, "carouselDelay": 3}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png"}}',
        jumpPanelSn: null,
        sort: 12,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86"}, {"col_0": "二月", "col_1": "112", "col_2": "134"}, {"col_0": "三月", "col_1": "456", "col_2": "235"}, {"col_0": "四月", "col_1": "145", "col_2": "84"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '累计出口额(万)',
        chartTitleTemplate: null,
        chartComponent: 'number',
        chartComponentType: 'Number',
        chartX: 670,
        chartY: 175,
        chartWidth: 260,
        chartHeight: 180,
        chartSet: '{"chartStyle": {"color": "#fff", "fontSize": 48}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 18}, "borderStyle": {"color": "#00F8FF", "border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 13,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "1200"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '网络零售额(万)',
        chartTitleTemplate: null,
        chartComponent: 'number',
        chartComponentType: 'Number',
        chartX: 980,
        chartY: 175,
        chartWidth: 260,
        chartHeight: 180,
        chartSet: '{"chartStyle": {"color": "#fff", "fontSize": 48}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 18}, "borderStyle": {"color": "#00F8FF", "border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 14,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "1200"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '零售交易额(亿美元)',
        chartTitleTemplate: null,
        chartComponent: 'areaLine',
        chartComponentType: 'LineChart',
        chartX: 680,
        chartY: 730,
        chartWidth: 540,
        chartHeight: 300,
        chartSet: '{"chartStyle": {"smooth": true, "isLabel": true, "carousel": false, "fontSize": 12, "carouselDelay": 3}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png"}}',
        jumpPanelSn: null,
        sort: 15,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86"}, {"col_0": "二月", "col_1": "112", "col_2": "134"}, {"col_0": "三月", "col_1": "456", "col_2": "235"}, {"col_0": "四月", "col_1": "145", "col_2": "84"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '网络零售额行业分布',
        chartTitleTemplate: null,
        chartComponent: 'pie',
        chartComponentType: 'PieChart',
        chartX: 1310,
        chartY: 120,
        chartWidth: 540,
        chartHeight: 280,
        chartSet: '{"chartStyle": {"radius": 50, "isLabel": true, "carousel": false, "fontSize": 12, "isLegend": false, "labelContent": "percent", "carouselDelay": 3, "legendPosition": "top"}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png"}}',
        jumpPanelSn: null,
        sort: 16,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "杭州市", "col_1": "125"}, {"col_0": "温州市", "col_1": "200"}, {"col_0": "金华市", "col_1": "56"}, {"col_0": "舟山市", "col_1": "145"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: 'XX网络零售数据服务中心',
        chartTitleTemplate: null,
        chartComponent: 'text',
        chartComponentType: 'TextBlock',
        chartX: 777,
        chartY: 18,
        chartWidth: 370,
        chartHeight: 50,
        chartSet: '{"chartStyle": {}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 26}, "borderStyle": {"border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 17,
        chartViewData: {
          chartData: '[]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '网店活跃度',
        chartTitleTemplate: null,
        chartComponent: 'gaugeNumber',
        chartComponentType: 'Gauge',
        chartX: 1340,
        chartY: 430,
        chartWidth: 180,
        chartHeight: 240,
        chartSet: '{"chartStyle": {"max": "100", "unit": "", "color": "#ccc", "fontSize": 24, "arrowLength": 56}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"color": "#00F8FF", "border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 18,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "62", "index": 0}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '跨境零售额占比',
        chartTitleTemplate: null,
        chartComponent: 'gaugeNumber',
        chartComponentType: 'Gauge',
        chartX: 1630,
        chartY: 430,
        chartWidth: 180,
        chartHeight: 240,
        chartSet: '{"chartStyle": {"max": "100", "unit": "", "color": "#ccc", "fontSize": 24, "arrowLength": 56}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"color": "#00F8FF", "border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 19,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "40", "index": 0}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '跨境电商零售额(万美元)',
        chartTitleTemplate: null,
        chartComponent: 'independentNumber',
        chartComponentType: 'IndependentNumber',
        chartX: 673,
        chartY: 449,
        chartWidth: 560,
        chartHeight: 200,
        chartSet: '{"chartStyle": {"color": "#fff", "fontSize": 48}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 18}, "borderStyle": {"color": "#00F8FF", "border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 20,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "119200", "index": 0}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '跨境电商零售平台分布',
        chartTitleTemplate: null,
        chartComponent: 'pieCircular',
        chartComponentType: 'PieChart',
        chartX: 1310,
        chartY: 730,
        chartWidth: 540,
        chartHeight: 300,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12, "isLegend": false, "labelContent": "percent", "carouselDelay": 3, "externalRadius": 70, "internalRadius": 30, "legendPosition": "top"}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border2.png"}}',
        jumpPanelSn: null,
        sort: 21,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "杭州市", "col_1": "125"}, {"col_0": "温州市", "col_1": "200"}, {"col_0": "金华市", "col_1": "56"}, {"col_0": "舟山市", "col_1": "145"}]',
          initDataFlag: 1,
        },
      },
    ],
  },
  {
    panelName: '按区县出口贸易',
    templateId: 3,
    panelThumbnail: 'https://oss.qlinyun.com/test/picture/ni73RBbfycc3QWWYP4JJh2iPD6EQwBFc.jpg',
    panelWidth: 1920,
    panelHeight: 1080,
    panelProportion: '16:9',
    panelTitle: null,
    panelTemplate: null,
    backgroundType: 2,
    backgroundColor: '#071228',
    backgroundTemplate: 'https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/background3.png',
    jumpPanelSn: null,
    jumpDelaySecond: null,
    chartColors: 'sapphireBlue',
    chartViews: [
      {
        chartTitle: 'XX出口数据大屏(2022)',
        chartTitleTemplate: null,
        chartComponent: 'text',
        chartComponentType: 'TextBlock',
        chartX: 50,
        chartY: 12,
        chartWidth: 396,
        chartHeight: 50,
        chartSet: '{"chartStyle": {}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 26}, "borderStyle": {"border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 12,
        chartViewData: {
          chartData: '[]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '地图',
        chartTitleTemplate: null,
        chartComponent: 'mapChart',
        chartComponentType: 'MapChart',
        chartX: 90,
        chartY: 418,
        chartWidth: 514,
        chartHeight: 596,
        chartSet: '{"chartStyle": {"map": ["100000","330000"], "isLabel": true, "carousel": true, "fontSize": 12}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png"}}',
        jumpPanelSn: null,
        sort: 11,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "杭州市", "col_1": "125"}, {"col_0": "温州市", "col_1": "200"}, {"col_0": "金华市", "col_1": "56"}, {"col_0": "舟山市", "col_1": "145"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '累计出口额(万)',
        chartTitleTemplate: null,
        chartComponent: 'number',
        chartComponentType: 'Number',
        chartX: 117,
        chartY: 171,
        chartWidth: 390,
        chartHeight: 190,
        chartSet: '{"chartStyle": {"color": "#fff", "fontSize": 38}, "titleStyle": {"align": "center", "color": "#fff", "fontSize": 16}, "borderStyle": {"color": "#486CFF", "border": "none", "borderTemplate": ""}}',
        jumpPanelSn: null,
        sort: 12,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "12133456", "index": 0}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '月度出口额(万元)',
        chartTitleTemplate: null,
        chartComponent: 'areaLine',
        chartComponentType: 'LineChart',
        chartX: 642,
        chartY: 130,
        chartWidth: 555,
        chartHeight: 335,
        chartSet: '{"chartStyle": {"smooth": true, "isLabel": true, "carousel": false, "fontSize": 12}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png"}}',
        jumpPanelSn: null,
        sort: 13,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86"}, {"col_0": "二月", "col_1": "112", "col_2": "134"}, {"col_0": "三月", "col_1": "456", "col_2": "235"}, {"col_0": "四月", "col_1": "145", "col_2": "84"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '出口市场分布',
        chartTitleTemplate: null,
        chartComponent: 'pieCircular',
        chartComponentType: 'PieChart',
        chartX: 642,
        chartY: 485,
        chartWidth: 534,
        chartHeight: 301,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12, "isLegend": false, "externalRadius": 70, "internalRadius": 30}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png"}}',
        jumpPanelSn: null,
        sort: 14,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "杭州市", "col_1": "125"}, {"col_0": "温州市", "col_1": "200"}, {"col_0": "金华市", "col_1": "56"}, {"col_0": "舟山市", "col_1": "145"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '各区县出口额(万元)',
        chartTitleTemplate: null,
        chartComponent: 'verticalBar',
        chartComponentType: 'BarChart',
        chartX: 642,
        chartY: 803,
        chartWidth: 1135,
        chartHeight: 228,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png"}}',
        jumpPanelSn: null,
        sort: 15,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86"}, {"col_0": "二月", "col_1": "112", "col_2": "134"}, {"col_0": "三月", "col_1": "456", "col_2": "235"}, {"col_0": "四月", "col_1": "145", "col_2": "84"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '出口行业分布',
        chartTitleTemplate: null,
        chartComponent: 'pieCircular',
        chartComponentType: 'PieChart',
        chartX: 1257,
        chartY: 130,
        chartWidth: 635,
        chartHeight: 323,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12, "isLegend": false, "externalRadius": 70, "internalRadius": 30}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png"}}',
        jumpPanelSn: null,
        sort: 16,
        chartViewData: {
          chartData: '[{"col_0": "列1", "col_1": "列2", "col_2": "列3", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "杭州市", "col_1": "125"}, {"col_0": "温州市", "col_1": "200"}, {"col_0": "金华市", "col_1": "56"}, {"col_0": "舟山市", "col_1": "145"}]',
          initDataFlag: 1,
        },
      },
      {
        chartTitle: '出口国家分布',
        chartTitleTemplate: null,
        chartComponent: 'horizonBar',
        chartComponentType: 'BarChart',
        chartX: 1257,
        chartY: 482,
        chartWidth: 621,
        chartHeight: 307,
        chartSet: '{"chartStyle": {"isLabel": true, "carousel": false, "fontSize": 12}, "titleStyle": {"align": "left", "color": "#fff", "fontSize": 14}, "borderStyle": {"border": "template", "borderTemplate": "https://kylin-static.oss-cn-hangzhou.aliyuncs.com/customScreens/backgroundTemplate/border3.png"}}',
        jumpPanelSn: null,
        sort: 17,
        chartViewData: {
          chartData: '[{"col_0": "月份", "col_1": "杭州", "col_2": "温州", "col_3": "列4", "col_4": "列5", "col_5": "列6"}, {"col_0": "一月", "col_1": "234", "col_2": "86"}, {"col_0": "二月", "col_1": "112", "col_2": "134"}, {"col_0": "三月", "col_1": "456", "col_2": "235"}, {"col_0": "四月", "col_1": "145", "col_2": "84"}]',
          initDataFlag: 1,
        },
      },
    ],
  },
]
